import crypto from "crypto";

const ENCRYPTION_KEY = Buffer.from(
    "KvP8zW3x+y2nM1qR5jH9kL4bN6cD0fGhE7tY8wS3vA4=",
    "base64"
);

export function encryptClient(data: string): string {
    const iv = crypto.randomBytes(16);
    const cipher = crypto.createCipheriv("aes-256-cbc", ENCRYPTION_KEY, iv);
    let encrypted = cipher.update(data, "utf-8", "base64");
    encrypted += cipher.final("base64");
    return `${iv.toString("base64")}:${encrypted}`;
}

export function decryptClient(encryptedData: string): string {
    const [ivBase64, encrypted] = encryptedData.split(":");
    const iv = Buffer.from(ivBase64, "base64");
    const decipher = crypto.createDecipheriv("aes-256-cbc", ENCRYPTION_KEY, iv);
    let decrypted = decipher.update(encrypted, "base64", "utf-8");
    decrypted += decipher.final("utf-8");
    return decrypted;
}
